import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../actions'
import { doTrack } from '../../helpers/TaggingSerializer'
import conf from '../../config/config'

import LoadingError from '../../components/LoadingError/LoadingError'
import Sidebar from '../../components/Sidebar/Sidebar'
import Meta from '../../components/Meta/Meta'
import FAQAccordions from '../../components/FAQAccordions/FAQAccordions'
import LiveChat from '../../components/LiveChat/LiveChat'
import SearchBar from '../../components/SearchBar/SearchBar'

import './Nectar.scss'

class Nectar extends PureComponent {
  static waitForDataServer (dispatch, params, req, res) {
    return Promise
      .all([
        dispatch(actions.fetchSidebarNav(true)),
        dispatch(actions.fetchPageContent('nectar', true))
      ])
      .then(([sidebar, page]) => {
        if (page.payload.id === 0) {
          res.statusCode = 404
        }
      })
  }

  static waitForDataClient (store) {
    return (nextState, transition, callback) => {
      const { dispatch, getState } = store
      const state = getState()
      const page = state.page.page

      if (page && page.permalink === '/help/nectar/') {
        return callback()
      }

      dispatch(actions.fetchPageContent('nectar'))
        .then(() => { callback() })
        .catch(() => { callback() })
    }
  }

  componentDidMount () {
    const { actions, sidebar } = this.props
    if (!sidebar.length) actions.fetchSidebarNav()
    this.fireAnalytics()
  }

  fireAnalytics = () => {
    if (window.digitalData) {
      window.digitalData.page.pageInfo.pageName = 'ar:help:page:nectarcard'
      window.digitalData.page.pageInfo.templateTitle = 'help_PAGE_nectarcard'
    }

    doTrack('help_initialLoad')
  }

  render () {
    const { sidebar, page, error } = this.props
    const imgDir = conf.IMG_DIR + '/nectar'

    if (!page || error) return <LoadingError />

    return (
      <div id='page-nectar' className='helpfaq page page-nectar'>
        <div id='helpfaqcontent' tabIndex='-1' />

        <Meta pagemeta={page} />

        <div className='container sticky-nav'>
          <div className='xs-row xs-row--negative lg-row'>
            <Sidebar activePage='/help/nectar/' links={sidebar} sticky />
          </div>
        </div>

        <div className='nectar-conent font-argos sticky-content'>

          <div className='nectar-banner'>
            <div className='container'>
              <div className='xs-row xs-row--negative'>
                <div className='xs-12 lg-9 lg-3-offset'>

                  <div className='xs-row xs-row--negative'>
                    <div className='nectar-banner__content'>
                      <div className='xs-12'>
                        <img className='nectar-banner__logo nectar-banner__item' src={`${imgDir}/nectar-logo.png`} alt='Nectar' />
                        <div className='nectar-banner__title'>Treat Yourself.<br />You can now spend your<br />nectar points online at argos</div>
                        <a className='button nectar-button nectar-banner__item' href='/webapp/wcs/stores/servlet/StoredCards'>
                          <p className='nectar-button__text'>Get started, sign in to Argos</p>
                        </a>
                      </div>
                    </div>
                    <div className='nectar-banner__image'>
                      <img className='nectar-product-lockup' src={`${imgDir}/nectar-product-lockup.png`} alt='NectarProducts' />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='nectar-info-section'>
          <div className='container'>
            <div className='xs-row xs-row--negative'>
              <div className='xs-12 lg-9 lg-3-offset'>
                <div className='xs-row xs-row--negative'>
                  <div className='xs-12'>
                    <h2 className='h2 section-title'>You can now spend Nectar points online at Argos</h2>
                    <div className='xs-row'>
                      <div className='xs-12 xs-12--none'>
                        <div className='xs-12--negative md-row'>
                          <div className='xs-12 md-6 xs-row spend-box'>
                            <h4 className='spend-text'>Spend from 500 (£2.50) to 40,000 (£200) points</h4>
                          </div>
                          <div className='xs-12 md-6 xs-row flex-div'>
                            <svg className='nectar-points-pill' width='305' height='74' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
                              <defs>
                                <rect className='nectar-points-pill__right' id='a' width='290' height='74' rx='37' />
                              </defs>
                              <g fill='none' fillRule='evenodd'>
                                <mask id='b' fill='#fff'>
                                  <use xlinkHref='#a' />
                                </mask><use fill='#471E5E' xlinkHref='#a' />
                                <path fill='#A793B2' mask='url(#b)' d='M0 0h145.982517l13.248252 37-13.248252 37H0z' />
                                <g mask='url(#b)'>
                                  <text fontSize='30' fontWeight='bold' letterSpacing='.46875' transform='translate(189 12)'>
                                    <tspan x='0' y='29' fill='#FFF'>£2.50</tspan>
                                  </text>
                                  <text fill='#FFF' transform='translate(203 44)' fontSize='14' fontWeight='300' letterSpacing='.5'>
                                    <tspan x='.245' y='13'>To spend</tspan>
                                  </text>
                                </g>
                                <g mask='url(#b)'>
                                  <text fontSize='30' fontWeight='bold' transform='translate(37 13)'>
                                    <tspan x='14' y='29' fill='#FFF'>500</tspan>
                                  </text>
                                  <text fontSize='14' fontWeight='300' letterSpacing='.5' transform='translate(37 13)'>
                                    <tspan x='.271' y='45' fill='#FFF'>Nectar points</tspan>
                                  </text>
                                </g>
                              </g>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='nectar-spend-online-section'>
            <div className='container'>
              <div className='xs-row xs-row--negative'>
                <div className='xs-12 lg-9 lg-3-offset'>
                  <div className='xs-row xs-row--negative'>
                    <div className='xs-12'>
                      <h2 className='h2 section-title'>Spend your points on argos.co.uk</h2>
                      <div className='xs-row'>
                        <div className='xs-12 xs-12--none'>
                          <div className='xs-row'>
                            <div className='spend-nectar-points'>
                              To spend your Nectar points, you'll need to link your Argos and Nectar accounts. Here's how:
                            </div>
                            <div className='xs-12 xs-row how-to-sign-in'>
                              <div className='xs-12 xs-12--none'>
                                <div className='xs-12--negative md-row'>
                                  <div className='xs-12 md-8 xs-row spend-box'>
                                    <div>
                                      <ol className='instructions'>
                                        <li> Sign in to your Argos account<div className='font-standard list-sub-text'>Go to 'Your Account' and select 'Ways to pay'</div></li>
                                        <li>Add your Nectar details<div className='font-standard list-sub-text'>You'll need your Nectar account info and card number</div>
                                        </li>
                                        <li>Choose how many points to spend when you check out</li>
                                      </ol>
                                    </div>
                                    <div className='xs-row xs-12'>
                                      <a className='button nectar-button purple-button' href='/webapp/wcs/stores/servlet/StoredCards'>
                                        <p className='purple-button__text'>Get started, sign in to Argos</p>
                                      </a>
                                    </div>
                                  </div>
                                  <div className='xs-12 md-4 xs-row flex-div side-image'>
                                    <div className='laptop-and-text'>
                                      <svg width='150' height='90' xmlns='http://www.w3.org/2000/svg'>
                                        <g fill='none' fillRule='evenodd'>
                                          <path d='M137.171 80.2H12.829a.983.983 0 0 0-.987.978v5.866c0 .54.442.978.987.978H137.17a.983.983 0 0 0 .987-.978v-5.866a.983.983 0 0 0-.987-.978zM.987 88.022h148.026M70.066 84.111h9.868' stroke='#912385' strokeWidth='2' strokeLinecap='round' />
                                          <path d='M132.237 1.978H17.763a.983.983 0 0 0-.987.978v76.266c0 .54.442.978.987.978h114.474a.983.983 0 0 0 .987-.978V2.956a.983.983 0 0 0-.987-.978z' stroke='#912385' strokeWidth='2' strokeLinecap='round' />
                                          <path stroke='#912385' strokeWidth='2' strokeLinecap='round' d='M23.19 75.311h103.62V7.844H23.19zM84.79 50.97l-9.802-8.664' />
                                          <path fill='#912385' d='M85.624 37.045l-21.248-4.452L71.06 52.83z' />
                                        </g>
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='nectar-spend-in-store-section'>
            <div className='container'>
              <div className='xs-row xs-row--negative'>
                <div className='xs-12 lg-9 lg-3-offset'>
                  <div className='xs-row xs-row--negative'>
                    <div className='xs-12'>
                      <h2 className='h2 section-title'>Spend your points in-store</h2>
                      <div className='xs-12 xs-12--none'>
                        <div className='xs-row'>
                          You'll need to have your Nectar card with you and pay at a staffed till.
                          <div className='xs-12 xs-row how-to-sign-in'>
                            <div className='xs-12 xs-12--none spend-points-text'>
                              <div className='xs-12--negative md-row'>
                                <div className='xs-12 md-8 xs-row spend-box'>
                                  <div>
                                    <ol className='instructions in-store'>
                                      <li> Visit any Argos store</li>
                                      <li>Have your Nectar card to hand when you pay at the till</li>
                                      <li>Choose how many points to spend (from 500 points/£2.50)</li>
                                    </ol>
                                  </div>
                                </div>
                                <div className='xs-12 md-4 xs-row flex-div side-image'>
                                  <div className='store-svg'>
                                    <svg width='150' height='92' xmlns='http://www.w3.org/2000/svg'>
                                      <g stroke='#912385' strokeWidth='2' fill='none' fillRule='evenodd'>
                                        <path d='M137.898 25.399V2c0-.552-.458-1-1.024-1h-91.85C44.459 1 44 1.448 44 2v22.979M44 30v59.394M138 90.184V30M66.506 51H57a3 3 0 0 0-3 3v17.219a3 3 0 0 0 3 3h9.506a3 3 0 0 0 3-3V54a3 3 0 0 0-3-3zM127.241 90.125V54.629c0-1.452-1.157-2.629-2.584-2.629H81.584C80.157 52 79 53.177 79 54.63v35.495' />
                                        <path strokeLinecap='round' strokeLinejoin='round' d='M36 30.207h109.404V26H36z' />
                                        <path d='M103 91.519V52M56 2v24.118M68 2v24.118M80 2v24.118M91 2v24.118M103 2v24.118M114 2v24.118M126 2v24.118M26 72v17.5M35.478 62c0-5.523-4.584-10-10.239-10C19.584 52 15 56.477 15 62s4.584 10 10.239 10c5.655 0 10.239-4.477 10.239-10zM20.871 89.75c0-4.28-3.553-7.75-7.936-7.75C8.553 82 5 85.47 5 89.75' />
                                        <path d='M1 90h148.026' strokeLinecap='round' />
                                      </g>
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='nectar-don-t-have-nectar-card-section'>
            <div className='container'>
              <div className='xs-row xs-row--negative'>
                <div className='xs-12 lg-9 lg-3-offset'>
                  <div className='xs-row xs-row--negative'>
                    <div className='xs-12'>
                      <p className='h2 section-title' />
                      <div className='xs-row'>
                        <div className='xs-12 xs-12--none'>
                          <div className='xs-row'>
                            <div className='sign-up-div'>
                              <div className='nectar-logo-sign-up'>
                                <img className='nectar-logo-sign-up__image' src={`${imgDir}/nectar-logo.png`} alt='Nectar' />
                              </div>
                              <div className='nectar-logo-sign-up nectar-logo-sign-up__text'>
                                <ul className='don-t-have-a-nectar'>
                                  <li className='don-t-have-a-nectar__text'>Don't have a Nectar card?</li>
                                  <li className='nectar-sign-up'><a className='button-link nectar-sign-up__text' target='_blank' href='https://www.nectar.com/'>Sign up here</a></li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div className='xs-12 xs-12--none'>
                            <p className='h2 section-title' />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='terms-and-conditions-section'>
          <div className='container'>
            <div className='xs-row xs-row--negative'>
              <div className='xs-12 lg-9 lg-3-offset'>
                <div className='xs-row xs-row--negative'>
                  <div className='xs-12'>
                    <h2 className='h2 section-title t-and-c-section'>Terms and Conditions</h2>
                    <div className='terms'>
                      <p className='terms__text'>
                        Read our Nectar&nbsp;
                        <a className='terms__link' href='/help/terms-and-conditions/'> Terms &amp; Conditions</a>
                        &nbsp;and&nbsp;
                        <a className='terms__link' href='https://privacy-hub.sainsburys.co.uk/privacy-policy/'>Privacy Policy</a>
                      </p>
                      <br />
                      <br />
                      <p className='terms__text'>Argos reserves the right to withdraw or amend the Nectar conversion process at any time and without notice.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='container ask-tpl-container'>
          <div className='xs-row xs-row--negative'>
            <div className='xs-12 lg-9 lg-3-offset content'>
              <div className='xs-row xs-row--negative'>
                <div className='xs-12'>
                  {/* eslint-disable jsx-a11y/anchor-has-content */}
                  {/* eslint-disable jsx-a11y/anchor-is-valid */}
                  <a id='nectarFAQs' aria-hidden='true' />
                  <FAQAccordions faqs={page.related_faqs} />
                  <LiveChat
                    actions={this.props.actions}
                    chatHasEnded={this.props.chatHasEnded}
                    chatLoading={this.props.chatLoading}
                    chatOnline={this.props.chatOnline}
                  />
                  <SearchBar position='bottom' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Nectar.propTypes = {
  sidebar: PropTypes.array,
  page: PropTypes.object,
  error: PropTypes.bool,
  actions: PropTypes.object,
  chatHasEnded: PropTypes.bool,
  chatLoading: PropTypes.bool,
  chatOnline: PropTypes.bool

}

function mapStateToProps (state) {
  return {
    sidebar: state.help.sidebar,
    page: state.page.page,
    error: state.page.pageError,
    chatHasEnded: state.page.chatHasEnded,
    chatLoading: state.page.chatLoading,
    chatOnline: state.page.chatOnline

  }
}

function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Nectar)
